var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "fixed-toggle-side-menu" }, [
      _c(
        "div",
        {
          staticClass: "toggle-side-menu",
          on: {
            click: function($event) {
              _vm.$emit("handleToggleSideMenu")
            }
          }
        },
        [
          _c("i", { staticClass: "icon-toggle-side-menu fa fa-caret-left" }),
          _vm._v(" "),
          _c("div", { staticClass: "tooltip-toggle-side-menu" })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isOpenAnalysisSubmenu,
              expression: "isOpenAnalysisSubmenu"
            }
          ],
          staticClass: "analysis-submenu",
          style: { top: _vm.submenuTop + "px" },
          on: {
            mouseenter: _vm.cancelCloseSubmenu,
            mouseleave: _vm.scheduleCloseSubmenu
          }
        },
        [
          _c(
            "ul",
            _vm._l(_vm.analysisSubmenu, function(sub) {
              return _c(
                "li",
                { key: sub.seq },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "item-menu",
                      attrs: {
                        to: { name: "Analysis", params: { id: sub.seq } }
                      }
                    },
                    [
                      _c("span", { staticClass: "nav-label" }, [
                        _vm._v(_vm._s(sub.menuName))
                      ])
                    ]
                  )
                ],
                1
              )
            }),
            0
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "sidebar-menu" }, [
      _c(
        "ul",
        { attrs: { id: "menu" } },
        [
          _vm._l(_vm.navbars, function(item) {
            return [
              item.routerName === "Analysis"
                ? _c(
                    "li",
                    {
                      key: item.routerName,
                      staticClass: "nav01_bg_color",
                      class: {
                        active: item.activeRouters.includes(_vm.$route.name)
                      },
                      on: {
                        mouseenter: function($event) {
                          _vm.openAnalysisSubmenu($event)
                        },
                        mouseleave: _vm.scheduleCloseSubmenu
                      }
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "item-menu",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                            }
                          }
                        },
                        [
                          _c("div", {
                            domProps: { innerHTML: _vm._s(item.icon) }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "nav-label" }, [
                            _vm._v(_vm._s(item.label))
                          ])
                        ]
                      )
                    ]
                  )
                : item.routerName === "Premium"
                ? _c(
                    "li",
                    {
                      key: item.routerName,
                      staticClass: "nav01_bg_color",
                      class: {
                        active: item.activeRouters.includes(_vm.$route.name)
                      },
                      attrs: { title: item.label }
                    },
                    [
                      _c(
                        _vm.isBasicPlan ? "a" : "router-link",
                        {
                          tag: "component",
                          staticClass: "item-menu",
                          attrs: {
                            href: _vm.isBasicPlan
                              ? "https://salemon.my.canva.site/premiumplan"
                              : null,
                            to: !_vm.isBasicPlan
                              ? { name: item.routerName }
                              : null,
                            target: _vm.isBasicPlan ? "_blank" : null
                          }
                        },
                        [
                          _c("div", {
                            domProps: { innerHTML: _vm._s(item.icon) }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "nav-label" }, [
                            _vm._v(_vm._s(item.label))
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _c(
                    "li",
                    {
                      key: item.routerName,
                      staticClass: "nav01_bg_color",
                      class: {
                        active: item.activeRouters.includes(_vm.$route.name)
                      },
                      attrs: { title: item.label }
                    },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "item-menu",
                          attrs: {
                            to: { name: item.routerName, params: item.params }
                          }
                        },
                        [
                          _c("div", {
                            domProps: { innerHTML: _vm._s(item.icon) }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "nav-label" }, [
                            _vm._v(_vm._s(item.label))
                          ])
                        ]
                      )
                    ],
                    1
                  )
            ]
          }),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "nav01_bg_color", attrs: { title: "ログアウト" } },
            [
              _c(
                "a",
                {
                  staticClass: "item-menu",
                  on: {
                    click: function($event) {
                      _vm.$emit("doLogout")
                    }
                  }
                },
                [
                  _c("i", {
                    staticClass: "fa fa-sign-out",
                    attrs: { "aria-hidden": "true" }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "nav-label" }, [
                    _vm._v("ログアウト")
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("li", { staticClass: "nav01_bg_color version-info" }, [
            _c("p", { staticClass: "text-white text-center" }, [
              _vm._v("version: " + _vm._s(_vm.appVersion))
            ])
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "footer text-center m-b-md" }, [
        _c(
          "a",
          {
            staticClass: "text--underline",
            attrs: { href: _vm.downloadUrl, download: "", target: "_blank" }
          },
          [_c("span", [_vm._v("利用規約")])]
        ),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "text--underline",
            attrs: { href: _vm.downloadUrlV2, download: "", target: "_blank" }
          },
          [_c("span", [_vm._v("プライバシーポリシー")])]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-edb195fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-edb195fe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarMenuPageLarge.vue
// module id = null
// module chunks = 